import React from 'react';
import Image from 'next/image';
import { useHandleSearch } from '@/hooks/useHandleSearch';

interface TenderMultiInfoCardProps {
  title: string;
  items: string[];
  poweredByAi: boolean;
}

export const TenderMultiInfoCard: React.FC<TenderMultiInfoCardProps> = ({ title, items, poweredByAi }) => {
  const { handleSearch } = useHandleSearch();

  return (
    <div className="card min-w-40 max-w-full rounded-lg bg-base-300">
      <div className="card-body">
        <div className="flex">
          <p className="truncate text-sm leading-6 text-primary opacity-80">{title}</p>
          {poweredByAi && (
            <div>
              <Image src="/assets/ai-powered-dark-gray-blue.png" alt="AI-powered" width={20} height={10} />
            </div>
          )}
        </div>
        <ul className="flex flex-wrap">
          {items.map((item, index) => (
            <li
              key={index}
              onClick={() => handleSearch(item)}
              className="badge-lg mr-2 mt-2 flex cursor-pointer items-center justify-center whitespace-pre-wrap rounded-full bg-base-200 text-xs leading-3 text-primary opacity-90 transition duration-200 ease-in-out hover:bg-primary hover:text-primary-content"
            >
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
